import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { EventBroadcastService } from '../../services/event-broadcast.service';
import { FormsModule } from '@angular/forms';
import { UserPreferencesService } from '../../services/user-preferences.service';
import { SpeedUnits } from '../../models/speed-units';
import { WeightUnits } from '../../models/weight-units';
import { PowerUnits } from '../../models/power-units';
import { TorqueUnits } from '../../models/torque-units';
import { LengthUnits } from '../../models/length-units';
import { UserPreferences } from '../../models/user-preferences';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-user-preferences-modal',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './user-settings-modal.component.html',
  styleUrl: './user-settings-modal.component.scss'
})
export class UserPreferencesModalComponent implements OnInit {
  @Input({ required: true }) modalId?: string;
  @Output() okEvent = new EventEmitter();

  mph = SpeedUnits.mph;
  kmh = SpeedUnits.kmh;
  lb = WeightUnits.lb;
  kg = WeightUnits.kg;
  hp = PowerUnits.hp;
  cv = PowerUnits.cv;
  kw = PowerUnits.kw;
  lbft = TorqueUnits.ftlb;
  kgfm = TorqueUnits.kgfm;
  nm = TorqueUnits.nm;

  speedUnits = SpeedUnits;
  weightUnits = WeightUnits;
  powerUnits = PowerUnits;
  torqueUnits = TorqueUnits;
  lengthUnits = LengthUnits;

  userPreferences: UserPreferences = new UserPreferences();

  constructor(private eventBroadcastService: EventBroadcastService, private userPreferencesService: UserPreferencesService, private activeModal: NgbActiveModal) { }
  ngOnInit(): void {
    this.userPreferencesService.getUserPreferences()
      .subscribe(preferences => this.userPreferences = preferences);;
  }

  ok() {
    this.userPreferencesService.setUserPreferences(this.userPreferences)
      .subscribe({
        next: this.activeModal.close
      });
  }

  close() {
    this.activeModal.dismiss();
  }
}
